<template>
  <BaseSelect v-model="lang" class="language-selector">
    <option value="nl" :selected="locale === 'nl'">
      {{ $t("languages.be") }}
    </option>
    <option value="fr" :selected="locale === 'fr'">
      {{ $t("languages.fr") }}
    </option>
  </BaseSelect>
</template>

<script setup lang="ts">
const { locale, setLocale } = useI18n();
const lang = ref(locale.value);

watch(lang, async () => {
  await setLocale(lang.value);

  // Subsequent GraphQL calls should use the right language in the jafolders-context header
  const { $urqlResetCache } = useNuxtApp();
  $urqlResetCache();

  // We clear this to make sure the infinite loading component does not end up in a funky state.
  clearNuxtData();
  clearNuxtState();
});
</script>

<style lang="scss" scoped>
.language-selector {
  height: 68px;
}
</style>
